import React from 'react';
import FaqsLayout from './faqs-layout';

export default class Faqs extends React.Component<{}, {}> {
    render(){
        return(
            <FaqsLayout/>
        )
    }
}